class OfficeTaskQueue {
  private queue: (() => Promise<void>)[] = [];
  private running = false;

  enqueue(task: () => Promise<void>) {
    this.queue.push(task);
    if (!this.running) {
      this.runNext();
    }
  }

  private async runNext() {
    if (this.queue.length === 0) {
      this.running = false;
      return;
    }

    this.running = true;
    const task = this.queue.shift()!;

    try {
      await task();
    } catch (err: any) {
      if (err.code === "RichApi.Error") {
        console.warn("Office busy, retrying task...");
        await new Promise((r) => setTimeout(r, 33));
        this.queue.unshift(task);
      } else {
        console.error("Office task failed:", err);
      }
    } finally {
      setTimeout(() => this.runNext(), 0);
    }
  }
}

export const officeQueue = new OfficeTaskQueue();
export function runOfficeTask(task: () => Promise<void>) {
  officeQueue.enqueue(task);
}
